<template>
  <v-container fill-height>
    <v-row justify="center" align="center" fill-height style="height: 100%">
      <v-col class="text-center">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
export default {
  async mounted() {
    let url = "/";
    if (this.$route.query.rurl && this.$route.query.rurl != "undefined")
      url = this.$route.query.rurl;
      
    if (this.$route.query.rm && this.$route.query.rurl) {
      try {
        let userAgent = navigator.userAgent;
        await axios.post(
          "https://d3k49jhriitw3f.cloudfront.net/analytics/richmenu/save",
          {
            richmenu_id: this.$route.query.rm,
            type: "link",
            value: this.$route.query.rurl,
            useragent: userAgent,
          },
          {
            headers: {
              "api-key": "1-2-3-sharks-landed",
            },
          }
        );
      } catch (error) {
        console.error(error);
      }
    }

    location.href = url != "/" ? decodeURIComponent(url) : "/";
  },
};
</script>

<style lang="scss" scoped></style>
